'use client';
import React, { useEffect } from 'react';

const Hamburger = () => {
	useEffect(() => {
		const elementId = 'sidenav';
		const element = document.getElementById(elementId);
		if (!element) return;

		const handleResize = () => {
			if (window.innerWidth >= 768) {
				element.classList.remove('-translate-x-[100%]');
				element.classList.remove('translate-x-0');
			}
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return (
		<button
			aria-label="Hamburger"
			className="flex md:hidden flex-col gap-1 "
			onClick={() => {
				if (window.innerWidth < 768) {
					const elementId = 'sidenav';
					const element = document.getElementById(elementId);
					if (!element) return;

					// toggle x translate
					element.classList.toggle('-translate-x-[100%]');
					element.classList.toggle('translate-x-0');
				}
			}}
		>
			<span className="w-4 h-[2px] bg-dove-white"></span>
			<span className="w-4 h-[2px] bg-dove-white"></span>
			<span className="w-4 h-[2px] bg-dove-white"></span>
		</button>
	);
};

export default Hamburger;
